export default __webpack_public_path__ + "static/media/Group 140.14db4ec5.svg";